import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';

import { Dialog } from 'components/shared';

import { Employee } from './EmployeeSelector';
import PreferredEmployees, {
  PreferredEmployee,
  CreatedBy
} from './PreferredEmployees';

type Props = {
  open: boolean;
  date: Date;
  employees: PreferredEmployee[];
  createdBy: CreatedBy;
  dialogContainer: HTMLElement;
  showProposed?: boolean;
  addEmployee: (employee: Employee) => Promise<void>;
  removeEmployee: (employee: Employee) => Promise<void>;
  onHidden: () => void;
};

export default function PreferredEmployeesDialog(props: Props) {
  const {
    open = true,
    date,
    employees,
    createdBy,
    dialogContainer,
    showProposed,
    addEmployee,
    removeEmployee,
    onHidden
  } = props;
  const { t } = useTranslation('common');
  const [hide, setHide] = useState(false);

  return (
    <Dialog
      title={t(
        showProposed
          ? 'flexMatchDialog.addProposedEmployees'
          : 'preferredEmployees'
      )}
      open={hide ? false : open}
      onHidden={onHidden}
      container={dialogContainer}
      PaperProps={{
        sx: { minWidth: 600 }
      }}
    >
      <PreferredEmployees
        date={date}
        employees={employees}
        createdBy={createdBy}
        onlyFlex={createdBy === 'FLEX_PLANNER'}
        addEmployee={addEmployee}
        removeEmployee={removeEmployee}
        showProposed={showProposed}
      />
      <DialogActions>
        <Button
          onClick={() => setHide(true)}
          color="secondary"
          variant="contained"
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
